import {generateRandomId, MediaDetectionType} from '@legit-health/ui';
import {Vector2d} from 'konva/lib/types';

export default function createDetection({
  detectionType,
  point,
  image
}: {
  detectionType: MediaDetectionType;
  point: Vector2d;
  image: HTMLImageElement;
}) {
  const minWidth = Math.min(image.width - point.x, image.width * 0.4);
  const minHeight = Math.min(image.height - point.y, image.width * 0.4);
  const width = Math.min(minWidth, minHeight);
  return {
    rect: {
      topLeft: {
        x: point.x,
        y: point.y
      },
      width,
      height: width
    },

    type: detectionType,
    id: generateRandomId()
  };
}
